(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui/reflection"), require("@bingads-webui/url-util"), require("@bingads-webui/registry"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui/reflection", "@bingads-webui/url-util", "@bingads-webui/registry"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui/reflection"), require("@bingads-webui/url-util"), require("@bingads-webui/registry")) : factory(root["underscore"], root["@bingads-webui/reflection"], root["@bingads-webui/url-util"], root["@bingads-webui/registry"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__39__, __WEBPACK_EXTERNAL_MODULE__42__, __WEBPACK_EXTERNAL_MODULE__47__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 91);
/******/ })
/************************************************************************/
/******/ ({

/***/ 39:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__39__;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__47__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(92);


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createProperty", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.createProperty;
  }
});
Object.defineProperty(exports, "createParameter", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.createParameter;
  }
});
Object.defineProperty(exports, "createType", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.createType;
  }
});
Object.defineProperty(exports, "createPrimitiveType", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.createPrimitiveType;
  }
});
Object.defineProperty(exports, "createCollectionType", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.createCollectionType;
  }
});
Object.defineProperty(exports, "compileProperties", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.compileProperties;
  }
});
Object.defineProperty(exports, "compileParameters", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.compileParameters;
  }
});
Object.defineProperty(exports, "createResolveType", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.createResolveType;
  }
});
Object.defineProperty(exports, "ONEOF_TYPE_PREFIX", {
  enumerable: true,
  get: function get() {
    return _typesPluginShared.ONEOF_TYPE_PREFIX;
  }
});
Object.defineProperty(exports, "createNavigation", {
  enumerable: true,
  get: function get() {
    return _resourceIdentifiersShared.createNavigation;
  }
});
Object.defineProperty(exports, "createCastNavigation", {
  enumerable: true,
  get: function get() {
    return _resourceIdentifiersShared.createCastNavigation;
  }
});
Object.defineProperty(exports, "createWithKeyNavigation", {
  enumerable: true,
  get: function get() {
    return _resourceIdentifiersShared.createWithKeyNavigation;
  }
});
Object.defineProperty(exports, "createCallNavigation", {
  enumerable: true,
  get: function get() {
    return _resourceIdentifiersShared.createCallNavigation;
  }
});
Object.defineProperty(exports, "createResourceIdentifier", {
  enumerable: true,
  get: function get() {
    return _resourceIdentifiersShared.createResourceIdentifier;
  }
});

var _typesPluginShared = __webpack_require__(93);

var _resourceIdentifiersShared = __webpack_require__(94);

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createResolveType = createResolveType;
exports.compileParameters = compileParameters;
exports.compileProperties = compileProperties;
exports.createType = createType;
exports.createPrimitiveType = createPrimitiveType;
exports.createProperty = createProperty;
exports.createParameter = createParameter;
exports.createCollectionType = createCollectionType;
exports.ONEOF_TYPE_PREFIX = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _reflection = __webpack_require__(39);

var _registry = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ONEOF_TYPE_PREFIX = '@ONEOF';
exports.ONEOF_TYPE_PREFIX = ONEOF_TYPE_PREFIX;
const COLLECTION_TYPE_POSTFIX = '@COLL';

function isOneOfType(typeName) {
  return typeName.indexOf(ONEOF_TYPE_PREFIX) === 0;
}

function hasPostfix(str, postfix) {
  return str.slice(-postfix.length) === postfix;
}

function removePostfix(str, postfix) {
  return str.slice(0, -postfix.length);
}

function createResolveType(oneOfTypes, types, OneOfType) {
  return function resolveType(name, namespace) {
    if (hasPostfix(name, COLLECTION_TYPE_POSTFIX)) {
      return resolveType(removePostfix(name, COLLECTION_TYPE_POSTFIX), namespace).collectionType;
    }

    if (isOneOfType(name)) {
      if (!oneOfTypes.has(name)) {
        const prefixLength = ONEOF_TYPE_PREFIX.length + 1;
        const typeNames = name.substr(prefixLength, name.length - prefixLength - 1).split(','); // eslint-disable-next-line no-use-before-define

        oneOfTypes.set(name, new OneOfType({
          typeNames
        }));
      }

      return oneOfTypes.get(name);
    }

    return types.resolve(name, namespace);
  };
}
/**
 * @typedef {Object} ParameterInfo
 * @property {String} typeName - The name of the parameter's type
 *
 * @memberof CallableType#
 * @this CallableType
 * @param {Object.<String, ParameterInfo>} parameters - The parameters to compile
 * @param {Object.Parameter} Parameter - The Parameter object
 * @return {Object.<String, Parameter>} A mapping for name to compiled Parameters
 */


function compileParameters(parameters, Parameter = Object) {
  const namespace = this.namespace;
  return _underscore.default.mapObject(parameters, ({
    typeName
  }, name) => new Parameter({
    name,
    namespace,
    typeName
  }));
}
/**
 * @typedef {Object} PropertyInfo
 * @property {String} typeName - The name of the propertie's type
 *
 * @memberof ObjectType#
 * @this ObjectType
 * @param {Object.<String, PropertyInfo>} properties - The properties to be compiled
 * @param {Object.Property} Property - The Property object
 * @return {Object.<String, Property>} a mapping for name to compiled Properties
 */


function compileProperties(properties, Property = Object) {
  const namespace = this.namespace;
  return _underscore.default.mapObject(properties, ({
    typeName
  }, name) => new Property({
    name,
    typeName,
    namespace
  }));
}

function createType(types) {
  /**
   * @class Type
   * @property {String} name - The qualified name of the type
   * @property {String} namespace - The namespace of the type
   * @property {String} shortName - The short name of the type
   */
  // eslint-disable-next-line no-unused-vars
  return class Type {
    /**
     * Create and register a type
     * A side effect of Type creation is registering itself to the type registry
     * @param {Object} options - The constructor options
     * @param {String} options.name - The name of the type
     * @return {void}
     */
    constructor({
      name
    }) {
      _underscore.default.chain(this).defineConstProperty('name', name).defineConstProperty('namespace', _registry.Registry.getNamespace(name)).defineConstProperty('shortName', _registry.Registry.getShortName(name)).value();

      types.register(this);
    }

  };
}

function createPrimitiveType(Superclass = Object) {
  /**
   * @class PrimitiveType
   * @extends Type
   * @property {Class} jsType - The corresponding JavaScript type
   */
  return class PrimitiveType extends Superclass {
    /**
     * Create a PrimitiveType
     * @param {Object} options - The constructor options
     * @param {String} options.name - The name of the type
     * @param {Class} options.jsType - The JavaScript type of the primitive type
     * @return {void}
     */
    constructor({
      name,
      jsType
    }) {
      super({
        name
      });
      (0, _reflection.defineConstProperty)(this, 'jsType', jsType);
    }

  };
}

function createProperty(resolveType) {
  /**
   * @class Property
   * @property {String} name - The name of the property
   * @property {String} typeName - The name of the property's type
   * @property {Type} type - The type of the property
   */
  return class Property {
    /**
     * Create a property
     * @param {Object} options - The constructor options
     * @param {String} options.name - The name of the property
     * @param {String} options.typeName - The name of the propertie's type
     * @param {String} options.namespace - The namespace of the propertie's type
     * @return {void}
     */
    constructor({
      name,
      typeName,
      namespace
    }) {
      _underscore.default.chain(this).defineConstProperty('name', name).defineConstProperty('typeName', typeName).defineProducedProperty('type', () => resolveType(typeName, namespace)).value();
    }

  };
}

function createParameter(resolveType) {
  /**
   * @class Parameter
   * @property {String} name - The name of the parameter
   * @property {String} typeName - The name of the paramter's type
   * @property {type} type - The type of the parameter
   */
  return class Parameter {
    /**
     * Create a parameter
     * @param {Object} options - The constructor options
     * @param {String} options.name - The name of the parameter
     * @param {String} options.typeName - The name of the parameter's type
     * @param {String} options.namespace - The namespace of the parameter's type
     * @return {void}
     */
    constructor({
      name,
      typeName,
      namespace
    }) {
      _underscore.default.chain(this).defineConstProperty('name', name).defineConstProperty('typeName', typeName).defineProducedProperty('type', () => resolveType(typeName, namespace)).value();
    }

  };
}

function createCollectionType(Superclass = Object, resolveType) {
  /**
   * @class CollectionType
   * @extends ObjectType
   * @property {String} elementTypeName - The name of the element type
   * @property {Type} elementType - The type of the elements
   */
  return class CollectionType extends Superclass {
    /**
     * Create a CollectionType
     * @param {Object} options - The constructor options
     * @param {Object.<String, PropertyInfo>} options.properties - The property definition
     * @param {String} options.baseTypeName - The name of the base type
     * @param {String} options.elementTypeName - The name of the element type
     * @return {void}
     */
    constructor({
      properties,
      baseTypeName,
      elementTypeName
    }) {
      super({
        name: CollectionType.collectionTypeName(elementTypeName),
        properties,
        baseTypeName
      });

      _underscore.default.chain(this).defineConstProperty('elementTypeName', elementTypeName).defineProducedProperty('elementType', () => resolveType(this.elementTypeName, this.namespace)).value();
    }
    /**
     * Get the CollectionType's name from it's element type name
     * @param {String} typeName - The name of the elementType
     * @return {String} The name of the CollectionType
     */


    static collectionTypeName(typeName) {
      return `${typeName}${COLLECTION_TYPE_POSTFIX}`;
    }

  };
}

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNavigation = createNavigation;
exports.createCastNavigation = createCastNavigation;
exports.createWithKeyNavigation = createWithKeyNavigation;
exports.createCallNavigation = createCallNavigation;
exports.createResourceIdentifier = createResourceIdentifier;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _reflection = __webpack_require__(39);

var urlUtil = _interopRequireWildcard(__webpack_require__(42));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createNavigation() {
  /**
   * @class Navigation
   * @property {ResourceIdentifier} source - The source accessor navigated from
   */
  return class Navigation {
    constructor({
      source
    }) {
      (0, _reflection.defineConstProperty)(this, 'source', source);
    }

    toJSON() {
      return [...this.source.toJSON(), this.toSelfJSON()];
    }

    toSelfJSON() {
      throw new Error('I\'m abstract');
    }

  };
}

function createCastNavigation(Superclass = Object, url, edm) {
  /**
   * @class CastNavigation
   * @extends Navigation
   * @property {Type} type - The type casting to
   * @property {String} name - The type name used for casting
   */
  return class CastNavigation extends Superclass {
    constructor({
      source,
      type,
      name = type.name
    }) {
      super({
        source
      });

      _underscore.default.chain(this).defineConstProperty('type', type).defineConstProperty('name', name).value();

      (0, _reflection.defineConstProperty)(this, 'path', url.join(source.path, name));
    }

    toSelfJSON() {
      return {
        type: 'function',
        name: CastNavigation.navigationName,
        parameters: [this.name]
      };
    }

    static get navigationName() {
      return '$cast';
    }

    static defineOn(TypeResID) {
      /**
       * $cast navigation method of the TypeResID
       * @memberof TypeResID#
       * @this TypeResID
       * @param {String} name - The name of the subclass
       * @returns {TypeResID} The ResourceIdentifier to access the subclass object
       */
      function navCastMethod(name) {
        const entityType = edm.types.resolve(name, this.type.namespace);
        const type = TypeResID.prototype.type instanceof edm.types.CollectionType ? entityType.collectionType : entityType;
        const navigation = new CastNavigation({
          source: this,
          type: entityType,
          name
        });
        return new type.ResourceIdentifier({
          navigation
        });
      }

      (0, _reflection.defineConstProperty)(TypeResID.prototype, CastNavigation.navigationName, navCastMethod);
    }

  };
}

function createWithKeyNavigation(Superclass = Object) {
  /**
   * @class WithKeyNavigation
   * @extends Navigation
   * @property {String|Number} key - The key of the selected entity
   * @property {String|Number} ignoreKeyTypeInPath - By default false. If true, compose path following /<path>/<id>
   */
  return class WithKeyNavigation extends Superclass {
    constructor({
      source,
      key,
      ignoreKeyTypeInPath
    }) {
      super({
        source
      });
      (0, _reflection.defineConstProperty)(this, 'key', key);
      (0, _reflection.defineConstProperty)(this, 'path', (() => {
        // In case people pass a decimal string for a integer key
        // We cannot use parseInt directly, it would get a wrong number if the
        // key is beyond Number.MAX_SAFE_INTEGER
        if (_underscore.default.isString(key)) {
          if (ignoreKeyTypeInPath) {
            return urlUtil.join(source.path, key);
          }

          const keyType = _underscore.default.chain(source).result('type').result('elementType').result('keyProperty').result('typeName').value();

          if (keyType === 'integer') {
            if (key.match(/^[+-]?(0|[1-9][0-9]*)$/)) {
              return `${source.path}(${key})`;
            }
          }

          if (keyType === 'string') {
            return `${source.path}('${key}')`;
          }
        }

        return `${source.path}(${JSON.stringify(key)})`;
      })());
    }

    toSelfJSON() {
      return {
        type: 'function',
        name: WithKeyNavigation.navigationName,
        parameters: [this.key]
      };
    }

    static get navigationName() {
      return '$withKey';
    }

    static defineOn(TypeResID) {
      /**
       * $withKey navigation method of the TypeResID
       * @memberof TypeResID#
       * @this TypeResID
       * @param {String} key - The key of the element
       * @param {Boolean} ignoreKeyTypeInPath - Decide how to add key to path
       * @returns {ResourceIdentifier}
       * The ResourceIdentifier to access the element with the given key
       */
      function navWithKeyMethod(key, ignoreKeyTypeInPath = false) {
        const navigation = new WithKeyNavigation({
          source: this,
          key,
          ignoreKeyTypeInPath
        });
        return new this.type.elementType.ResourceIdentifier({
          navigation
        });
      }

      (0, _reflection.defineConstProperty)(TypeResID.prototype, WithKeyNavigation.navigationName, navWithKeyMethod);
    }

  };
}

function createCallNavigation(Superclass = Object, edm) {
  /**
   * @class CallNavigation
   * @extends Navigation
   * @property {Object} parameters - The parameters for the function call
   */
  return class CallNavigation extends Superclass {
    constructor({
      source,
      parameters = {}
    }) {
      super({
        source
      });
      (0, _reflection.defineConstProperty)(this, 'parameters', parameters);
      const path = source.type instanceof edm.types.ActionType ? source.path : `${source.path}(${_underscore.default.map(parameters, (value, name) => `${name}=${value}`).join(',')})`;
      (0, _reflection.defineConstProperty)(this, 'path', path);
    }

    toSelfJSON() {
      return {
        type: 'function',
        name: CallNavigation.navigationName,
        // for callable, parameters are named
        parameters: [this.parameters]
      };
    }

    static get navigationName() {
      return '$call';
    }

    static defineOn(TypeResID) {
      /**
       * $call navigation method of the TypeResID
       * @memberof TypeResID#
       * @this TypeResID
       * @param {object} parameters - The parameters to call the callable
       * @return {ResourceIdentifier}
       * The ResourceIdentifier accessing the return value of the callable
       */
      function navCallMethod(parameters) {
        const navigation = new CallNavigation({
          source: this,
          parameters
        });
        return new this.type.returnType.ResourceIdentifier({
          navigation
        });
      }

      (0, _reflection.defineConstProperty)(TypeResID.prototype, CallNavigation.navigationName, navCallMethod);
    }

  };
}

function createResourceIdentifier() {
  /**
   * @class ResourceIdentifier
   * @property {Navigation} navigation
   * - The navigation back tracking the parent ResourceIdentifier
   */
  return class ResourceIdentifier {
    /**
     * Create a ResourceIdentifier
     * @param {Object} [options] - The constructor options
     * @param {Navigation} [options.navigation]
     * - The navigation back tracking the parent ResourceIdentifier
     * @return {Void} Nothing to return
     */
    constructor({
      navigation
    } = {}) {
      if (navigation) {
        (0, _reflection.defineConstProperty)(this, 'navigation', navigation);
        (0, _reflection.defineConstProperty)(this, 'path', navigation.path);
      } else {
        (0, _reflection.defineConstProperty)(this, 'path', '');
      }
    }

    toJSON() {
      if (this.navigation) {
        return this.navigation.toJSON();
      }

      return [];
    }

    identifyEntitySet(json) {
      // eslint-disable-next-line
      let entitySet = this;
      /* eslint guard-for-in: 0 */

      /* eslint no-restricted-syntax: 0 */

      for (const i in json) {
        const item = json[i];

        if (item.type === 'property') {
          entitySet = entitySet[item.name];
        } else if (item.type === 'function') {
          entitySet = entitySet[item.name](...item.parameters);
        }

        if (!entitySet) {
          return null;
        }
      }

      return entitySet;
    }

  };
}

/***/ })

/******/ });
});
